import React from "react"

import PropTypes from "prop-types"

import * as styles from "./iframe.module.scss"

const Iframe = ({ height, url, title, aspectRatio, border }) => (
  <iframe
    className={`${styles.iframe} ${border ? styles.iframe__border : ""}`}
    height={height}
    allowFullScreen
    title={title}
    src={url}
    style={aspectRatio ? { aspectRatio } : {}}
  />
)

export default Iframe

Iframe.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  height: PropTypes.string,
  aspectRatio: PropTypes.string,
  border: PropTypes.bool,
}

Iframe.defaultProps = {
  aspectRatio: null,
  height: null,
  border: false,
}
